import React, { useEffect, useState } from 'react';
import { useAuth } from '@/context/AuthContext';
import * as Sentry from '@sentry/react';

const WASTE_TYPES = [
    'Paper',
    'General Waste',
    'Plastic',
    'Scrap Metal',
    'Glass',
    'Hazardous sry',
    'Tetrapack'
];

const WasteTypeInput = () => {
    const { apiFetch } = useAuth();
    const [percentages, setPercentages] = useState(
        WASTE_TYPES.reduce((acc, type) => ({ ...acc, [type]: '' }), {})
    );
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    useEffect(() => {
        const fetchPercentages = async () => {
            setLoading(true);
            setMessage('');
            try {
                const response = await apiFetch('/api/Ops/waste-types');
                const data = await response.json();
                const mapped = WASTE_TYPES.reduce((acc, type) => {
                    const found = data.find(d => d.wasteType === type);
                    acc[type] = found ? found.percentage : '';
                    return acc;
                }, {});
                setPercentages(mapped);
            } catch (catchError) {
                Sentry.captureException(catchError);
                setMessage('Failed to load.');
            } finally {
                setLoading(false);
            }
        };
        fetchPercentages();
    }, [apiFetch]);

    const handleChange = (type, value) => {
        if (value === '' || (/^\d{1,3}$/.test(value) && Number(value) <= 100)) {
            setPercentages(prev => ({ ...prev, [type]: value }));
        }
    };

    const handleSave = async () => {
        setSaving(true);
        setMessage('');
        const payload = Object.entries(percentages).map(([type, percent]) => ({
            wasteType: type,
            percentage: Number(percent) || 0
        }));
        try {
            const response = await apiFetch('/api/Ops/waste-types', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) setMessage('Saved!');
            else setMessage('Save failed.');
        } catch (catchError) {
            Sentry.captureException(catchError);
            setMessage('Save failed.');
        } finally {
            setSaving(false);
        }
    };

    return (
        <div>
            <h2>Waste Type Percentages</h2>
            {loading ? (
                <div>Loading...</div>
            ) : (
                <table>
                    <thead>
                        <tr>
                            <th>Waste Type</th>
                            <th>Percentage (%)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {WASTE_TYPES.map(type => (
                            <tr key={type}>
                                <td>{type}</td>
                                <td>
                                    <input
                                        type="number"
                                        min="0"
                                        max="100"
                                        value={percentages[type]}
                                        onChange={e => handleChange(type, e.target.value)}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
            {message && <div>{message}</div>}
            <button onClick={handleSave} disabled={saving}>
                {saving ? 'Saving...' : 'Save'}
            </button>
        </div>
    );
};

export default WasteTypeInput;